export default function ModalLoading({ visible, message = 'Enviando información...' }) {
    if (!visible) return null;

    const backdropStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000
    };

    const modalStyle = {
        background: '#fff',
        padding: '1.5rem',
        borderRadius: '0.5rem',
        textAlign: 'center',
        maxWidth: '320px',
        width: '90%'
    };

    const spinnerStyle = {
        width: '40px',
        height: '40px',
        border: '5px solid #e5e7eb',
        borderTop: '5px solid #3b82f6',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        margin: '0 auto 1rem'
    };

    return (
        <div style={backdropStyle}>
            <div style={modalStyle}>
                <div style={spinnerStyle}></div>
                <p>{message}</p>
            </div>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
}
